"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.settings.title': 'Chat Settings',
    'chat.settings.media_generation': 'Media Generation',
    'chat.settings.image_model': 'Image Model',
    'chat.settings.video_model': 'Video Model',
    'chat.settings.voice.label': 'Voice',
    'chat.settings.chat_learning.label': 'Learn about user from chat conversation',
    'chat.settings.chat_learning.description': 'The system will analyze your conversations from time to time and will adjust its style of response to the way you interact with the system',
    'chat.settings.enable_ai_assistant.label': 'Enable AI Assistant',
    'chat.settings.enable_ai_assistant.description': 'Enable AI Assistant to provide intelligent suggestions and help during your conversations',
    'chat.settings.enable_ai_assistant.disabled_tooltip': 'AI Assistant is not available with your current plan. Please upgrade to access this feature.',
    'chat.settings.save': 'Save',
    'chat.settings.saved': 'Settings saved successfully',
    'chat.settings.ai_parameters': 'AI Parameters',
    'chat.settings.temperature.label': 'Temperature',
    'chat.settings.temperature.description': 'Controls randomness in AI responses. Lower values make responses more focused and deterministic, higher values make them more creative and varied.',
    'chat.settings.temperature.min_label': 'Strict',
    'chat.settings.temperature.max_label': 'Creative',
    'chat.settings.assistance_setup': 'Assistance Setup',
    'chat.settings.max_tokens.label': 'Response Length',
    'chat.settings.max_tokens.description': 'Controls the maximum length of AI responses. Default uses model settings, while other options limit response length.',
    'chat.settings.max_tokens.default': 'Default (Model Setting)',
    'chat.settings.max_tokens.short': 'Short',
    'chat.settings.max_tokens.medium': 'Medium',
    'chat.settings.max_tokens.long': 'Long',
    'chat.settings.extended_context.label': 'Extended Context',
    'chat.settings.extended_context.description': 'Enable extended context mode to maintain longer conversation memory and better understanding of previous messages',
    'chat.settings.thinking.label': 'Enable Thinking',
    'chat.settings.thinking.description': 'Show AI reasoning and thought process during response generation',
};
